import { render, staticRenderFns } from "./CareSummaryList.vue?vue&type=template&id=38124bf9&"
import script from "./CareSummaryList.vue?vue&type=script&lang=ts&"
export * from "./CareSummaryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports